import React from 'react';
import { connect } from 'react-redux';
import { useAsync, useAsyncFn } from 'react-use';
import { bindActionCreators } from 'redux';

import fetchSalon from 'actions/fetchSalon.action';
import bePutSendSms from 'actions/salon/bePutSendSms.action';
import feSetThemeMode from 'actions/salon/feSetThemeMode.action';
import ICO_CALENDAR from 'assets/images/icons/calendar-empty-black.svg';
import Foldout from 'components/generic/Foldout.component';
import OverlaySpinner from 'components/generic/OverlaySpinner.component';
import withSalonId from 'components/hoc/withSalonId.hoc';
import { useTranslation } from 'providers/GILT.provider';
import { useCalendarMode } from 'providers/Theme.provider';
import logger from 'utils/logger.util';
import asObject from 'utils/objects/asObject.util';

import SectionContent from 'settings/online-booking/pages/SectionContent.component';
import SectionSeparator from 'settings/online-booking/pages/SectionSeparator.component';
import SectionTitle from 'settings/online-booking/pages/SectionTitle.component';
import ColorMode from 'settings/page-elements/no-show-visibility/ColorMode.component';

const USE_SPINNER = true;

const L = logger('ColorModeLayout');

const ColorModeLayout = ({ bePutSendSms, fetchSalon, feSetThemeMode, salonId }) => {
  const { t } = useTranslation();
  const calendarMode = useCalendarMode();

  const [{ loading: isLoadingMode, error: errorMode }, handleSaveColorMode] = useAsyncFn(
    async ({ raw }) => {
      if (raw === null) return;

      const result = await bePutSendSms({ salonId, calendar_mode: raw?.id });

      if (result.is.ok) {
        feSetThemeMode(asObject(result.json).calendar_mode);
      } else {
        L.warn('handleSaveColorMode()', 'result:', result);
      }
    },
    [bePutSendSms, salonId, feSetThemeMode],
  );

  const { loading: isLoadingSalon, error: errorSalon } = useAsync(async () => {
    if (calendarMode) return;
    return fetchSalon(salonId);
  }, [calendarMode, fetchSalon, salonId]);

  const isSpinnerRendered = USE_SPINNER && isLoadingMode && isLoadingSalon;
  if (errorMode || errorSalon) L.warn('()', { errorMode, errorSalon });

  return (
    <div data-bem="ColorModeLayout">
      {isSpinnerRendered && <OverlaySpinner />}
      <Foldout
        tag="ColorModeLayout__foldout"
        src={ICO_CALENDAR}
        title={t('staffAndBusiness.calendarSettings.title1')}
        width="lg"
        isOpen
      >
        <SectionSeparator />
        <SectionTitle>{t('staffAndBusiness.calendarSettings.description1')}</SectionTitle>

        <SectionContent>
          <ColorMode onChange={handleSaveColorMode} value={calendarMode} />
        </SectionContent>
      </Foldout>
    </div>
  );
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchSalon,
      bePutSendSms,
      feSetThemeMode,
    },
    dispatch,
  );

const ColorModeLayoutHoc = connect(null, mapDispatchToProps)(withSalonId(ColorModeLayout));

export default ColorModeLayoutHoc;
